'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSucceeded = undefined;

var _identity = require('transmute/identity');

var _identity2 = _interopRequireDefault(_identity);

var _asyncStatuses = require('../constants/asyncStatuses');

var _requestStateUpdate = require('./requestStateUpdate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set status when a request succeeds
 *
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
 */
var requestSucceeded = exports.requestSucceeded = (0, _requestStateUpdate.requestStateUpdate)(_asyncStatuses.SUCCEEDED, _identity2.default);